import moment from 'moment';

export const DATE_FORMAT = 'YYYY-MM-DD';

export type PeriodPreset = 'lastWeek' | 'lastMonth' | 'lastYear';

export interface PeriodRange {
    from: string;
    to: string;
}

/**
 * Traduce un atajo de periodo a un rango de fechas cerrado.
 * `now` se inyecta para poder testear sin depender del reloj.
 */
export const getPeriodRange = (preset: PeriodPreset, now: Date = new Date()): PeriodRange => {
    const to = moment(now);
    const from = moment(now);

    switch (preset) {
        case 'lastMonth':
            from.subtract(1, 'month');
            break;
        case 'lastYear':
            from.subtract(1, 'year');
            break;
        case 'lastWeek':
        default:
            from.subtract(7, 'days');
            break;
    }

    return { from: from.format(DATE_FORMAT), to: to.format(DATE_FORMAT) };
};
